import { addMinutes } from "date-fns";
import { sortBy } from "lodash";
import { STRIP_PRIORITY_TRAILER_KEY_SEPARATOR } from "./constants";

export const buildStripPriorityQueryString = (
  dockStartTime,
  planDate,
  terminalId
) =>
  `dockStartTime=${dockStartTime}&planDate=${planDate}&terminalId=${terminalId}`;

export const sortStripPriorityTrailers = (data) =>
  sortBy(data || [], "unldgRanking");

export const sortStripPriorityShipments = (data) =>
  sortBy(data || [], [
    (shipment) => shipment.routeName,
    (shipment) => shipment.stopSequence,
  ]);

export const getUniqueKeyForStripPriorityRowData = (
  trailerNumber,
  trailerScac
) => {
  return `${trailerNumber?.toUpperCase()}${STRIP_PRIORITY_TRAILER_KEY_SEPARATOR}${trailerScac?.toUpperCase()}`;
};

export const getShipmentsPrintGroupOrder = ({
  selectedTrailers = [],
  trailerDisplayOrder = [],
}) => {
  if (selectedTrailers.length > 0) {
    return selectedTrailers;
  }
  return trailerDisplayOrder;
};

export const getShipmentsPrintSectionHeaderDetails = (shipments = []) => {
  const trailerNumber = shipments[0]?.trailerNumber;
  const headerDetails = [];
  if (trailerNumber) {
    headerDetails.push({ label: "Trailer#", value: trailerNumber });
  }
  headerDetails.push({ label: "Total Shipments", value: shipments.length });
  return headerDetails;
};

export const appendTimeInMinutesToDate = (
  planDate,
  defaultDockStartTimeInMins
) => {
  const dateWithTime = addMinutes(
    new Date(planDate),
    defaultDockStartTimeInMins
  );
  return dateWithTime.toISOString();
};
